import {
  Box,
  Typography,
  Tabs,
  Tab,
  Grid,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../../services/api";
import { useAuth } from "../../../context/AuthContext";

const ViewEmployeePage = () => {
  const { id } = useParams();
  const { token } = useAuth();

  const [tab, setTab] = useState(0);
  const [employee, setEmployee] = useState<any>(null);
  const [contract, setContract] = useState<any>(null);
  const [payroll, setPayroll] = useState<any[]>([]);

  useEffect(() => {
    if (!id) return;
    const fetchData = async () => {
      try {
        const [empRes, contractRes, payrollRes] = await Promise.all([
          api.get(`/employees/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          api.get(`/contracts?employeeId=${id}`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          api.get(`/payroll?employeeId=${id}`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);
        setEmployee(empRes.data);
        setContract(contractRes.data[0]);
        setPayroll(payrollRes.data);
      } catch (err) {
        console.error("Failed to load employee data", err);
      }
    };
    fetchData();
  }, [id, token]);

  if (!employee) return <Typography>Loading...</Typography>;

  return (
    <Box p={4}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Employee Details
      </Typography>

      <Tabs value={tab} onChange={(_, newVal) => setTab(newVal)}>
        <Tab label="Profile" />
        <Tab label="Contract" />
        <Tab label="Salaries" />
        <Tab label="Leave" />
      </Tabs>

      {tab === 0 && (
        <Box mt={3}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}><strong>Full Name:</strong> {employee.fullName}</Grid>
            <Grid item xs={12} sm={6}><strong>National ID:</strong> {employee.nationalId}</Grid>
            <Grid item xs={12} sm={6}><strong>Phone:</strong> {employee.phone}</Grid>
            <Grid item xs={12} sm={6}><strong>Email:</strong> {employee.email || "—"}</Grid>
            <Grid item xs={12} sm={6}><strong>Position:</strong> {employee.position}</Grid>
            <Grid item xs={12} sm={6}><strong>Department:</strong> {employee.department || "—"}</Grid>
            <Grid item xs={12} sm={6}><strong>Start Date:</strong> {new Date(employee.startDate).toLocaleDateString()}</Grid>
            <Grid item xs={12} sm={6}><strong>Status:</strong> {employee.status}</Grid>
          </Grid>
        </Box>
      )}

      {tab === 1 && (
        <Box mt={3}>
          {contract ? (
            <Paper elevation={2} sx={{ p: 3 }}>
              <Typography variant="h6">Contract Details</Typography>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} sm={6}><strong>Start Date:</strong> {new Date(contract.startDate).toLocaleDateString()}</Grid>
                <Grid item xs={12} sm={6}><strong>End Date:</strong> {contract.endDate ? new Date(contract.endDate).toLocaleDateString() : "—"}</Grid>
                <Grid item xs={12} sm={6}><strong>Salary:</strong> ${contract.salary.toFixed(2)}</Grid>
                <Grid item xs={12} sm={6}><strong>Status:</strong> {contract.status}</Grid>
              </Grid>
              <Box mt={2}>
                <Typography fontWeight="bold">Components</Typography>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Type</TableCell>
                      <TableCell>Label</TableCell>
                      <TableCell>Amount</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {contract.components.map((c: any, idx: number) => (
                      <TableRow key={idx}>
                        <TableCell>{c.type}</TableCell>
                        <TableCell>{c.label}</TableCell>
                        <TableCell>${c.amount.toFixed(2)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Paper>
          ) : (
            <Typography>No contract found.</Typography>
          )}
        </Box>
      )}

      {tab === 2 && (
        <Box mt={3}>
          <Typography variant="h6" gutterBottom>Salaries</Typography>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Gross</TableCell>
                <TableCell>Tax</TableCell>
                <TableCell>Net</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {payroll.map((row) => (
                <TableRow key={row._id}>
                  <TableCell>{new Date(row.payrollDate).toLocaleDateString()}</TableCell>
                  <TableCell>${row.grossSalary.toFixed(2)}</TableCell>
                  <TableCell>${row.taxes.toFixed(2)}</TableCell>
                  <TableCell>${row.netPay.toFixed(2)}</TableCell>
                </TableRow>
              ))}
              {payroll.length === 0 && (
                <TableRow><TableCell colSpan={4} align="center">No salary records found.</TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      )}

      {tab === 3 && (
        <Box mt={3}>
          <Typography variant="h6">Leave Days Accrued</Typography>
          <Typography>— Feature placeholder (data to be implemented)</Typography>
        </Box>
      )}
    </Box>
  );
};

export default ViewEmployeePage;
